export default __webpack_public_path__ + "static/media/DailyBooks.da22fd03.png";